import { render, staticRenderFns } from "./SelectedPersonInfo.vue?vue&type=template&id=786f5d37&scoped=true"
import script from "./SelectedPersonInfo.vue?vue&type=script&lang=js"
export * from "./SelectedPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./SelectedPersonInfo.vue?vue&type=style&index=0&id=786f5d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f5d37",
  null
  
)

export default component.exports